import React from "react";
import { Page, Text, View } from "@react-pdf/renderer";
import DataController from "@controllers/DataController";
import * as PDFStyles from "./PDFStyles";
import { Html } from "react-pdf-html";
import { IPDFSummaryOfWork } from "./PDFTypes";

const PDFSummaryOfWork: React.FC<IPDFSummaryOfWork> = (props) => {
  return (
    <>
      {props.isHCPC && props.summaryOfWork ? (
        <Page
          size="A4"
          style={PDFStyles.styles.page}
        >
          <View
            style={PDFStyles.styles.heading}
            fixed
          >
            <Text style={PDFStyles.styles.headingText}>{"ParaFolio"}</Text>
          </View>
          <View
            fixed
            style={PDFStyles.styles.pageHeader}
            render={({ pageNumber }) => (
              <>
                <Text style={PDFStyles.styles.pageHeaderText}>{"Summary of Work"}</Text>
                <Text style={PDFStyles.styles.pageNumber}>{pageNumber - 1}</Text>
              </>
            )}
          />
          <View style={PDFStyles.styles.pageInnerContainer}>
            <View>
              <Text style={PDFStyles.styles.standardsHeaderOverview}>{"Summary of Work"}</Text>
              <View style={PDFStyles.styles.separator} />
            </View>
            <Html
              style={{ fontSize: 12 }}
              stylesheet={PDFStyles.htmlStyles}
            >
              {DataController.decodeHTML(props.summaryOfWork)}
            </Html>
          </View>
        </Page>
      ) : null}
    </>
  );
};

export default PDFSummaryOfWork;
